import { create } from "zustand";

import type { OdbNode, OdbSide } from "../../api/types";

/** Presse-papiers interne de l'éditeur (⌘C / ⌘V d'une branche) : une branche copiée se colle comme subordonné
 *  dans un ordre de bataille du même camp, ouvert ou un autre. Codes vidés à la copie. */
interface OdbClipboard {
  side: OdbSide | null;
  node: OdbNode | null;
  copy: (side: OdbSide, node: OdbNode) => void;
}

export const useOdbClipboard = create<OdbClipboard>((set) => ({
  side: null,
  node: null,
  copy: (side, node) => set({ side, node }),
}));
